module.exports = __webpack_public_path__ + "static/media/NavTransactionIcon.e79786df.svg";